import React, { useState } from "react";
import { IconButton, Avatar, Menu, MenuItem } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";

const UserMenu = ({
  user,
  role,
  avatarSrc,
  handleLogout,
  navigate,
  getProfileRoute,
  menuOpen,
  anchorEl,
  setMenuOpen,
  setAnchorEl,
}) => {
  const [avatarError, setAvatarError] = useState(false);

  if (!user) {
    return (
      <IconButton component={Link} to="/login" color="inherit">
        <AccountCircleIcon />
      </IconButton>
    );
  }

  return (
    <>
      <IconButton
        color="inherit"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setMenuOpen(true);
        }}
        sx={{ p: 0 }}
      >
        {avatarSrc && !avatarError ? (
          <Avatar
            src={avatarSrc}
            alt={user.name || user.username}
            onError={() => setAvatarError(true)}
            sx={{ width: 32, height: 32 }}
          />
        ) : (
          <PersonIcon />
        )}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen && Boolean(anchorEl)}
        onClose={() => {
          setMenuOpen(false);
          setAnchorEl(null);
        }}
        MenuListProps={{
          onMouseLeave: () => {
            setMenuOpen(false);
            setAnchorEl(null);
          },
        }}
      >
        <MenuItem
          onClick={() => {
            navigate(getProfileRoute(role));
            setMenuOpen(false);
            setAnchorEl(null);
          }}
        >
          My Profile
        </MenuItem>
        {user?.role === "vendor" && !user?.isRegistration && (
          <>
            <MenuItem
              onClick={() => {
                navigate(`/store/${user._id}`);
                setMenuOpen(false);
                setAnchorEl(null);
              }}
            >
              My Store
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate("/vendor/my-activity");
                setMenuOpen(false);
                setAnchorEl(null);
              }}
            >
              My Activity
            </MenuItem>
          </>
        )}
        {user?.role === "agent" && !user?.isRegistration && (
          <MenuItem
            onClick={() => {
              navigate("/agent/my-activity");
              setMenuOpen(false);
              setAnchorEl(null);
            }}
          >
            My Activity
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleLogout();
            setMenuOpen(false);
            setAnchorEl(null);
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;